/*
  GREEN PAWLY Hauptnavigation – Öffnen/Schließen der Panels (snippets/gp-nav.liquid).
  Maus: öffnet nach kurzer Verzögerung, schließt beim Verlassen (mit Toleranz).
  Klick/Touch/Tastatur: Button schaltet um. Escape und Klick außerhalb schließen.
*/
(() => {
  const nav = document.querySelector('[data-gp-nav]');
  if (!nav || nav.dataset.gpNavReady) return;
  nav.dataset.gpNavReady = '1';

  const items = [...nav.querySelectorAll('[data-gp-nav-item].has-panel')];
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  let openTimer = null;
  let closeTimer = null;

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    const trigger = item.querySelector('.gp-nav__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    items.forEach((item) => { if (item !== except) setOpen(item, false); });
  }

  items.forEach((item) => {
    const trigger = item.querySelector('.gp-nav__trigger');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = !item.classList.contains('is-open');
      closeAll(item);
      setOpen(item, willOpen);
    });

    if (canHover) {
      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => { closeAll(item); setOpen(item, true); }, 90);
      });
      item.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(item, false), 180);
      });
    }

    // Tastatur: Fokus verlässt Menüpunkt samt Panel → schließen
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = items.find((item) => item.classList.contains('is-open'));
    if (!open) return;
    setOpen(open, false);
    open.querySelector('.gp-nav__trigger').focus();
  });

  document.addEventListener('click', (event) => {
    if (!nav.contains(event.target)) closeAll();
  });
})();
